module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/logo-ol-ebc-main_44dc6d5.png";